export type BlockType = BasicType;

export enum BasicType {
    PAGE = 'page',
    SECTION = 'section',
    COLUMN = 'column',
    GROUP = 'group',
    TEXT = 'text',
    IMAGE = 'image',
    DIVIDER = 'divider',
    SPACER = 'spacer',
    BUTTON = 'button',
    WRAPPER = 'wrapper',
    RAW = 'raw',
    ACCORDION = 'accordion',
    ACCORDION_ELEMENT = 'accordion-element',
    ACCORDION_TITLE = 'accordion-title',
    ACCORDION_TEXT = 'accordion-text',
    HERO = 'hero',
    CAROUSEL = 'carousel',
    NAVBAR = 'navbar',
    SOCIAL = 'social',
    TEMPLATE = 'template',
    TABLE = 'table',
    TABLE_COLUMN = 'table-column',
    TABLE_ROW = 'table-row',

}

export enum AdvancedType {
    TEXT = 'advanced_text',
    IMAGE = 'advanced_image',
    DIVIDER = 'advanced_divider',
    SPACER = 'advanced_spacer',
    BUTTON = 'advanced_button',
    NAVBAR = 'advanced_navbar',
    SOCIAL = 'advanced_social',
    ACCORDION = 'advanced_accordion',
    CAROUSEL = 'advanced_carousel',
    WRAPPER = 'advanced_wrapper',
    SECTION = 'advanced_section',
    COLUMN = 'advanced_column',
    GROUP = 'advanced_group',
    HERO = 'advanced_hero',
    TABLE = 'advanced_table',
    TABLE_ROW = 'advanced_table_row'
}

export const MERGE_TAG_CLASS_NAME = 'easy-email-merge-tag-container';
export const EMAIL_BLOCK_CLASS_NAME = 'email-block';
